import React from 'react'
import Styles from './Loading.module.css'

export default function Loading(props) {
    return (
        <div className={Styles.Loading}>
            <i className='fas fa-spinner fa-pulse'></i>
        </div>
    )
}